// TODO: remove if not needed since default Ant Design Checkbox already has correct styles
import React from "react"
import { Checkbox as AntCheckbox, Tooltip } from "antd"
import PropTypes from "prop-types"

// styles
import "./checkbox.scss"

const Checkbox = ({
  id, // not an antd Checkbox prop
  label, // TODO: use children instead
  className,
  children,
  tooltip = null,
  tooltipPlacement = "top",
  ...otherProps // defaultChecked, onChange (evt.target.checked)
}) => {
  const classNames = `prime-checkbox${className ? ` ${className}` : ""}`

  return (
    <AntCheckbox
      id={id}
      className={classNames}
      {...otherProps}
    >
      <Tooltip
        title={tooltip}
        placement={tooltipPlacement}
      >
        {children || label}
      </Tooltip>
    </AntCheckbox>
  )
}

Checkbox.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  defaultChecked: PropTypes.bool,
  tooltip: PropTypes.string,
  checked: PropTypes.bool, // controlled component
}

export default Checkbox
